import { Monitor, Moon, Sun } from 'lucide-react'
import {
  Button, Menu, MenuContent, MenuLabel, MenuRadioGroup, MenuRadioItem, MenuTrigger,
  useTheme, type ThemePreference,
} from '@bb/ui'
import { de } from '../i18n'

/**
 * The same Hell/Dunkel/System control apps/web ships (its own ThemeMenu.tsx),
 * built against the same `useTheme`/`initTheme` in @bb/ui so both
 * applications read `data-theme` and `bb.theme` identically — this is its
 * own copy of the component, not an import, per the same reasoning as
 * apps/admin/src/api/client.ts.
 */
export function ThemeMenu() {
  const { preference, theme, setTheme } = useTheme()
  const ThemeIcon = theme === 'dark' ? Moon : Sun

  return (
    <Menu>
      <MenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={de.theme.label}>
          <ThemeIcon className="size-4" />
        </Button>
      </MenuTrigger>
      <MenuContent>
        <MenuLabel>{de.theme.label}</MenuLabel>
        <MenuRadioGroup value={preference} onValueChange={(v) => setTheme(v as ThemePreference)}>
          <MenuRadioItem value="light"><Sun className="size-3.5" />{de.theme.light}</MenuRadioItem>
          <MenuRadioItem value="dark"><Moon className="size-3.5" />{de.theme.dark}</MenuRadioItem>
          <MenuRadioItem value="system"><Monitor className="size-3.5" />{de.theme.system}</MenuRadioItem>
        </MenuRadioGroup>
      </MenuContent>
    </Menu>
  )
}
